import React, { useEffect, useState } from 'react'
import { useFeiyongTypeListQuery } from '../../store/NeiZhangFeiYongApi';
import { Form, Selector } from 'antd-mobile';

function ExpenseTypeSelectH5(props) {
    const [list,setList] = useState([]);
    const {data,isSuccess} =useFeiyongTypeListQuery({fyt_qy_id:props.e_id})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                const newArr = data.Result.map((item) => {
                    const {fyt_id,fyt_name }=item;
                    return item = {value:fyt_id,label:fyt_name }
                })
                setList(newArr)
            }else{
                setList([])
            }
        }
    },[data,isSuccess])
    return (
        <Form.Item 
            label={props.label}
            required={props.required}  
            style={props.formStyle}
            wrapperCol={props.wrapperCol}
            name={props.name}
        >
            <Selector
                options={list} 
                onChange={(_,f) => {
                    props.onChange(f.items[0].value,f.items[0].label,)
                }}
                placeholder={props.placeholder}
                style={props.style}
                allowClear
                onClear={props.onClear}
                disabled={props.disabled}
            />                
        </Form.Item>
    )
}

export default ExpenseTypeSelectH5